/**
 * Loading Screen Component
 *
 * Displays while authentication is in progress
 */

import { useEffect } from "react";
import loaderIcon from "../assets/svg/loader.svg";

interface LoadingScreenProps {
  onComplete?: () => void;
}

export function LoadingScreen({ onComplete }: LoadingScreenProps) {
  useEffect(() => {
    // Simulate loading for 2 seconds, then call onComplete
    const timer = setTimeout(() => {
      onComplete?.();
    }, 2000);

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className="min-h-screen bg-[#FAF6F1] dark:bg-[#1A2D47] flex flex-col">
      {/* Main Content */}
      <main className="flex-1 flex flex-col items-center justify-center px-6">
        {/* Spinner */}
        <div className="mb-8">
          <img src={loaderIcon} alt="" className="w-12 h-12 animate-spin" />
        </div>

        {/* Loading Text */}
        <p className="text-[#5B6B7A] text-lg font-normal text-center">
          DuneWorks is connecting your systems...
        </p>
      </main>
    </div>
  );
}
